import { ChangeEvent, FC, FocusEventHandler, memo, useMemo } from 'react'
import { CompanyType, PlanningApplicationType } from '@leadgen/models/client'
import Box from '@mui/material/Box'
import ApplicationTypeTile from './ApplicationTypeTile'

const ApplicationTypeGrid: FC<{
  companyType: CompanyType
  planningApplicationTypes: PlanningApplicationType[]
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ companyType, planningApplicationTypes, onChange, onBlur }) => {
  const selectedPlanningApplicationTypesSet = useMemo(() => {
    return new Set(planningApplicationTypes)
  }, [planningApplicationTypes])
  return (
    <Box
      component={'ul'}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 2,
        padding: 2,
        margin: 0,
      }}
    >
      {(companyType === 'builder' ||
        companyType === 'landscaper' ||
        companyType === 'flooring' ||
        companyType === 'kitchen' ||
        companyType === 'retail' ||
        companyType === 'glazier' ||
        companyType === 'renewables') && (
        <>
          <ApplicationTypeTile
            key={'listed'}
            planningApplicationType={'listed'}
            onChange={onChange}
            onBlur={onBlur}
            selected={selectedPlanningApplicationTypesSet.has('listed')}
          />
          <ApplicationTypeTile
            key={'unlisted'}
            planningApplicationType={'unlisted'}
            onChange={onChange}
            onBlur={onBlur}
            selected={selectedPlanningApplicationTypesSet.has('unlisted')}
          />
        </>
      )}
    </Box>
  )
  // {allPlanningApplicationTypes.map(planningApplicationType => {
  //   return (
  //     <ApplicationTypeTile
  //       key={planningApplicationType}
  //       planningApplicationType={planningApplicationType}
  //       onChange={onChange}
  //       onBlur={onBlur}
  //       selected={selectedPlanningApplicationTypesSet[planningApplicationType]}
  //     />
  //   )
  // })}
}

export default memo(ApplicationTypeGrid)
